<template>
	<v-container>
		<v-card class="mb-4" flat outlined>
			<v-card-title>{{title}}</v-card-title>
			<v-card-text>
				<v-data-iterator
					:items="usuarios"
					item-key="user"
				>
					<template v-slot:default="props">
						<v-row>
							<v-col
								v-for="item in props.items"
								:key="`col_${item.user}`"
								cols="12"
								sm="12"
								md="6"
								lg="6"
							>
								<v-card>
									<v-list dense>
										<v-list-item>
											<v-list-item-content>Rut:</v-list-item-content>
											<v-list-item-content class="align-end">
												{{ item.user }}
											</v-list-item-content>
										</v-list-item>
										<v-list-item>
											<v-list-item-content>Nombre:</v-list-item-content>
											<v-tooltip top color="primary">
												<template v-slot:activator="{ on, attrs }">
													<v-list-item-content
														v-on="on"
														class="align-end limit-text"
													>
														{{ item.nombre }}
													</v-list-item-content>
												</template>
												<span>{{item.nombre}}</span>
											</v-tooltip>
											
										</v-list-item>
									</v-list>
								</v-card>
							</v-col>
						</v-row>
					</template>
				</v-data-iterator>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
export default {
	name: 'Usuario',
	props:{
		usuarios:{
			type: Array,
			default: function(){
				return []
			}
		}
	},
	computed:{
		title(){
			let title = 'Usuario';

			if(!!this.usuarios)
				title += this.usuarios.length > 1? 's': ''

			return title;
		}
	},
	data () {
		return {

		}
	}
}
</script>

<style lang="css" scoped>
	.limit-text{
		text-overflow: ellipsis;
		white-space: nowrap;
	}
</style>